import { useParams } from "react-router-dom";
import DFEnterprisesTemplate from "../../../components/templates/clientes/DF/DFEnterprisesTemplate";

const DFEnterprises = () => {
    const params = useParams();
    const { id } = params;

    return <DFEnterprisesTemplate id={id}/>;
}

export default DFEnterprises;